import { BrowserRouter, Route, Routes } from "react-router-dom";

import "@/App.css";
import Marketing from "@/Marketing";
import Privacy from "@/pages/legal/Privacy";
import Security from "@/pages/legal/Security";
import Terms from "@/pages/legal/Terms";

function App() {
    return (
        <div className="App">
            <BrowserRouter>
                <Routes>
                    <Route path="/" element={<Marketing />} />
                    <Route path="/privacy" element={<Privacy />} />
                    <Route path="/terms" element={<Terms />} />
                    <Route path="/security" element={<Security />} />
                </Routes>
            </BrowserRouter>
        </div>
    );
}

export default App;
